export default __webpack_public_path__ + "static/media/c.7d19acd9.png";